import React from 'react'
import styled from 'styled-components'
import Badge from './Badge'
import FloorNumber from './FloorNumber'
import {DIRECTION} from '../FloorList'

const FloorItem = ({selected, dataKey, value, label, count, direction, onClick, onKeyDown}) => {
  const onSelected = () => onClick(value)

  return (
    <Container>
	   <ButtonContainer
	      onClick={onSelected}
	      onKeyDown={onKeyDown}
	      direction={direction}
	      data-key={dataKey}
	      role="button"
	      tabIndex="0"
	      aria-pressed = {selected}
	    >
	      <HighlightContainer selected={selected} direction={direction}>
	        <FloorNumber value={value} label={label} selected={selected} />
	        <Badge value={count} selected={selected} />
	      </HighlightContainer>
	    </ButtonContainer>
	  </Container>
  )
}

FloorItem.defaultProps = {
  label: 'Floor'
}

export default FloorItem

const Container = styled.li`
  display: flex;
`

const ButtonContainer = styled.div`
  min-height: 63px;
  max-height: 63px;
  min-width: 90px;
  max-width: 90px;
  background-color: #13294b;
  cursor: pointer;
  box-sizing: border-box;
  position: relative;
  flex: 1 0 0;
  padding: ${props => (props.direction === DIRECTION.HORIZONTAL ? '1px' : '0')};
  margin: 3px;
  
  &:focus{
    outline: 3px solid #FF9900;
  }
  
  @media (max-width: 420px) {
  min-height: 50px;
  max-height: 50px;
  min-width: 50px;
  max-width: 50px;
  margin: 7px 3px 7px 3px;
  }
`

const HighlightContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: ${props =>
    props.direction === DIRECTION.HORIZONTAL ? '6px' : '0'};
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  background-color: ${props => (props.selected ? '#646669' : '#13294b')};
`
